import axios from "../../../services/axios";
import { setlangauges } from "../slice/userAuthSlice";

// Async action to handle user login
export const asyncUserLogin =  async ({formData}) => {
    // Make the API call and directly return the response without error handling
    const response = await axios.post("/login", { ...formData });

    // Return the response data directly (success or failure response)
    return response;
  };






  



  